import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Projects } from "./pages/Projects";
import { HomePage } from "./pages/HomePage";
import { Gallery } from "./pages/Gallery";
import { ProjectDetails } from "./pages/ProjectDetails";
import { Partners } from "./pages/Partners";
import Contact from "./pages/Contact";
import { Blogs } from "./pages/Blogs";
import { BlogDetails } from "./pages/BlogDetails";
import { News } from "./pages/News";
import { Events } from "./pages/Events";
import { EventDetails } from "./pages/EventDetails";
import { Reports } from "./pages/Reports";
import PoshPolicy from "./poshpolicy/PoshPolicy";
import ComplaintofSexualHarassment from "./poshpolicy/ComplaintofSexualHarassment";
import Confidentiality from "./poshpolicy/Confidentiality";
import DutiesSS from "./poshpolicy/DutiesSS";
import ICC from "./poshpolicy/ICC";
import Preliminary from "./poshpolicy/Preliminary";
import Punishment from "./poshpolicy/Punishment";
import ReviewnApproval from "./poshpolicy/ReviewnApproval";
import SexualHarassment from "./poshpolicy/SexualHarassment";
import WhoComplainSexualHarassment from "./poshpolicy/WhoComplainSexualHarassment";
import Workplace from "./poshpolicy/Workplace";
import CSP from "./csppolicy/CSP";
import PolicyStatement from "./csppolicy/PolicyStatement";
import Scope from "./csppolicy/Scope";
import RiskMitigation from "./csppolicy/RiskMitigation";
import Recruitment from "./csppolicy/Recruitment";
import ReportingConcerns from "./csppolicy/ReportingConcerns";
import Allegations from "./csppolicy/Allegations";
import Enquiries from "./csppolicy/Enquiries";
import Bullying from "./csppolicy/Bullying";
import ITSM from "./csppolicy/ITSM";
import ConfidentialityCSP from "./csppolicy/ConfidentialityCSP";
import SafeguardingGroup from "./csppolicy/SafeguardingGroup";
import ReviewandApproval from "./csppolicy/ReviewandApproval";
import GoodPractices from "./csppolicy/GoodPractices";
import Annexure1 from "./csppolicy/Annexure1";
import Annexure2 from "./csppolicy/Annexure2";
import Annexure3 from "./csppolicy/Annexure3";
import Annexure4 from "./csppolicy/Annexure4";
import Annexure5 from "./csppolicy/Annexure5";
import Annexure6 from "./csppolicy/Annexure6";
import Career from "./pages/Career";
import Awards from "./pages/Awards";
import AwardDetails from "./pages/AwardDetails";
import { StaffMembers } from "./pages/StaffMembers";
import { FundraiserPage } from "./pages/FundraiserPage";
import { ParticipantFundraiserPage } from "./pages/ParticipantFundraiserPage";
import { Fundraisers } from "./pages/Fundraisers";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="" element={<HomePage />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:id" element={<ProjectDetails />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/partners" element={<Partners />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/staff-members" element={<StaffMembers />} />
      <Route path="/news" element={<News />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blogs/:id" element={<BlogDetails />} />
      <Route path="/events" element={<Events />} />
      <Route path="/events/:id" element={<EventDetails />} />
      <Route path="/reports" element={<Reports />} />
      <Route path="/career" element={<Career/>}/>
      <Route path="/awards" element={<Awards />} />
      <Route path="/awards/:id" element={<AwardDetails />} />
      <Route path="/fundraisers" element={<Fundraisers />} />
      <Route path="/fundraiser/:slug" element={<FundraiserPage />} />
      <Route
        path="/fundraiser/:slug/:participantSlug"
        element={<ParticipantFundraiserPage />}
      />
      <Route path="/poshpolicy" element={<PoshPolicy />}>
        <Route
          path="/poshpolicy/complaint-of-sexual-harassment"
          element={<ComplaintofSexualHarassment />}
        />
        <Route
          path="/poshpolicy/confidentiality"
          element={<Confidentiality />}
        />
        <Route path="/poshpolicy/duties" element={<DutiesSS />} />
        <Route path="/poshpolicy/icc" element={<ICC />} />
        <Route path="/poshpolicy/" element={<Preliminary />} />
        <Route path="/poshpolicy/punishment" element={<Punishment />} />
        <Route
          path="/poshpolicy/review-and-approval"
          element={<ReviewnApproval />}
        />
        <Route
          path="/poshpolicy/sexual-harassment"
          element={<SexualHarassment />}
        />
        <Route
          path="/poshpolicy/who-complain-sexual-harassment"
          element={<WhoComplainSexualHarassment />}
        />
        <Route path="/poshpolicy/workplace" element={<Workplace />} />
      </Route>
      <Route path="/csppolicy" element={<CSP/>}>
        <Route path="/csppolicy/" element={<PolicyStatement/>}/>
        <Route path="/csppolicy/scope" element={<Scope/>}/>
        <Route path="/csppolicy/risk-mitigation" element={<RiskMitigation/>}/>
        <Route path="/csppolicy/goodpractices" element={<GoodPractices/>}/>
        <Route path="/csppolicy/recruitment-and-training" element={<Recruitment/>}/>
        <Route path="/csppolicy/reporting-concerns" element={<ReportingConcerns/>}/>
        <Route path="/csppolicy/allegations" element={<Allegations/>}/>
        <Route path="/csppolicy/enquiries" element={<Enquiries/>}/>
        <Route path="/csppolicy/bullying" element={<Bullying/>}/>
        <Route path="/csppolicy/itsm" element={<ITSM/>}/>
        <Route path="/csppolicy/confidentiality" element={<ConfidentialityCSP/>}/>
        <Route path="/csppolicy/safeguarding-group" element={<SafeguardingGroup/>}/>
        <Route path="/csppolicy/review-and-approval" element={<ReviewandApproval/>}/>
        <Route path="/csppolicy/annexure1" element={<Annexure1/>}/>
        <Route path="/csppolicy/annexure2" element={<Annexure2/>}/>
        <Route path="/csppolicy/annexure3" element={<Annexure3/>}/>
        <Route path="/csppolicy/annexure4" element={<Annexure4/>}/>
        <Route path="/csppolicy/annexure5" element={<Annexure5/>}/>
        <Route path="/csppolicy/annexure6" element={<Annexure6/>}/>
      </Route>
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
